import isEqual from "lodash/isEqual";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import PropertyService from "../api/PropertyService";
import { propertyManagementActions } from "../store/property-management-slice";
import { PropertyUpdate } from "../types/property";

const getChangedFields = (
  original: PropertyUpdate,
  current: PropertyUpdate
): Partial<PropertyUpdate> => {
  const changes: Partial<PropertyUpdate> = {};

  Object.keys(current).forEach((key) => {
    const typedKey = key as keyof PropertyUpdate;

    if (isEqual(original[typedKey], current[typedKey])) {
      return;
    }

    (changes as any)[typedKey] = current[typedKey];
  });

  return changes;
};

export const useSaveProperty = () => {
  const dispatch = useDispatch();
  const { property, originalProperty } = useSelector(
    (state: any) => state.propertyManagement
  );
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const saveProperty = async () => {
    setIsSaving(true);
    
    try {
      await PropertyService.CreateProperty({
        ...property,
      });
    } catch (error: any) {
      setError(error.error ?? "Property konnte nicht gespeichert werden");
      throw error;
    } finally {
      setIsSaving(false);
      dispatch(propertyManagementActions.resetState());
    }
  };

  const updateProperty = async () => {
    if (!originalProperty) {
      return;
    }

    setIsSaving(true);
    try {
      const allChanges = getChangedFields(originalProperty, property);

      if (Object.keys(allChanges).length > 0) {
        const payload = {
          ...allChanges,
        };

        await PropertyService.UpdateProperty(property.id, payload);
      }
    } catch (error: any) {
      setError(error.error ?? "Property konnte nicht aktualisiert werden");
      throw error;
    } finally {
      setIsSaving(false);
      dispatch(propertyManagementActions.resetState());
    }
  };

  return { saveProperty, updateProperty, isSaving, error, setError };
};
